module.exports = __webpack_public_path__ + "static/media/7.33b66816.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/7.jpg
// module id = 1007
// module chunks = 0